import Details from "../models/Details";

export default class DetailsService {
  public static _getDetails(apiService: any, client = false, path = ""): Promise<Details[]> {
    return new Promise((resolve, reject) => {
      apiService
        .get(`${client ? "/client" : ""}/details${path}`, "")
        .then((detailsResult: any) => {
          if (!detailsResult.data) {
            resolve([]);
          } else {
            const items = detailsResult.data.map((doc: any) => {
              const detailData = doc;
              const retVal = { id: doc.id, ...detailData } as Details;
              return retVal;
            });
            resolve(items);
          }
        })
        .catch((error: any) => reject(error));
    });
  }

  public static getDetails(apiService: any): Promise<Details[]> {
    return this._getDetails(apiService, false);
  }
}
